import trim from '@nicolaudie-group/ng-ui-kit/helpers/trim'
import routeNames from '@/router/names'

/**
 * Redirect legacy WebHashHistory routes to new WebHistory routes
 * @param {Object} to - Resolved vue-router route
 * @returns Route to redirect to, or true if navigation should continue
 */
function redirectWebHashRoutes(to) {
  const path = trim(to.fullPath, '/').toLowerCase()
  const [p1, p2, p3, p4] = path.split('/')
  // If this is an old path, using vue-router WebHashHistory mode
  if (p1 === '#') {
    // If this is an old link to the editor
    if (p2 === 'editor' && p3) {
      /*
      Matches:
      - /#/editor/1234
      - /#/editor/1234/properties
      - /#/editor/1234/properties/foo
      - /#/editor/1234/properties?dialog=foo
      - /#/editor/1234/content
      - /#/editor/1234/content/foo
      - /#/editor/1234/content?dialog=foo
      - /#/editor/1234/foo

      And redirects to "/editor/1234/content" or "/editor/1234/properties"
      */
      return {
        name: (p4 && p4.startsWith('content')) ? routeNames.Content : routeNames.Properties,
        params: {
          profileUid: p3,
        },
      }
    }
    // If this is an old link to the home page
    if (p2 === 'home') {
      let routeName = routeNames.Home
      if (p3 === 'create?dialog=control-dialog-create-profile') {
        routeName = routeNames.Create
      } else if (p3 === 'create?dialog=control-dialog-upload-profile') {
        routeName = routeNames.Import
      }
      /*
      Matches:
      - /#/home
      - /#/home/create
      - /#/home/create?dialog=foo
      - /#/home/create?dialog=control-dialog-create-profile
      - /#/home/create?dialog=control-dialog-upload-profile
      - /#/home/create/foo

      And redirects to "/" or "/editor/create", or "/editor/import"
      */
      return {
        name: routeName,
      }
    }
  }
  return true
}

export default redirectWebHashRoutes
